  $(document).ready(function () {
    $('.collection .tct_tab').click(function () {
      var title = $(this).attr('data-title');
      $(this).addClass('active').siblings().removeClass("active");
      $(this).closest('.collection').find('slider-component[data-title="'+title+'"]').addClass('active').siblings().removeClass('active');
    });
    $('.faq__item').click(function (){ 
      if($(this).hasClass('active')){
         $('.faq__item').removeClass("active");
         $('.faq__answer').slideUp();
      }else{
         $('.faq__item').removeClass("active");
         $('.faq__answer').slideUp();
         $(this).find('.faq__answer').slideDown();
         $(this).addClass('active');
      }
    });


    $('.slidershow--slider').slick({
  dots: false,
  arrows:false,
  centerMode: false,
  slidesToShow: 1.5,
  slidesToScroll: 1,
  infinite:false,
  pauseOnHover:false,
  PauseOnFocus: false,
  autoplay: false,
  centerPadding: '0px',
  prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
  responsive: [
    {
      breakpoint: 779,
      settings: {
        centerPadding: '100px',
        slidesToShow: 1.1
      }
    }
  ]
});
    initSlider();
function initSlider() {
 $('.cart-drawer__collection').slick({
  dots: false,
  arrows:true,
  centerMode: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite:false,
  pauseOnHover:false,
  PauseOnFocus: false,
  autoplay: false,
  centerPadding: '0px',
  prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
  responsive: [
    {
      breakpoint: 779,
      settings: {
        centerPadding: '100px',
        slidesToShow: 1.1
      }
    }
  ]
});
    }
  })
/* // ....droplogicx nkd....... */
 var observer = new MutationObserver(function(mutationsList, observer) {
        for(var mutation of mutationsList) {
          if(mutation.addedNodes[0].id == "appstle_subscription_widget0"){
            // $('.custom__sbscription').css("opacity","1");
            $('.appstle_one_time_text').text("Buy for");
            $('.appstle_subscribe_save_text').text('Subscribe & Save 15%');
          }
            if (mutation.type === 'childList') {
                console.log('New element appended!');
            }
        }
    });
    observer.observe($('.product__info-wrapper .product-form')[0], { childList: true, subtree: true });
$('fieldset.product-form__input input[type="radio"]').change(function(){
    setTimeout(function(){
      $('.appstle_one_time_text').text("Buy for");
            $('.appstle_subscribe_save_text').text('Subscribe & Save 15%');
    },50);
});
/* // ....droplogicx nkd....... */
